import Popup from "devextreme-react/popup";
import AttachmentGrid from "./AttachmentGrid";
import { AttachmentProps } from "./types";

interface PopupProps extends AttachmentProps {
    visible: boolean;
    onClose: () => void;
}

const AttachmentPopup: React.FC<PopupProps> = ({
    visible,
    onClose,
    docId,
    docType
}) => {
    return (
        <Popup
            visible={visible}
            onHiding={onClose}
            width={900}
            height={600}
            title="Attachment"
            showCloseButton={true}
        >
            <AttachmentGrid docId={docId} docType={docType} />
        </Popup>
    );
};

export default AttachmentPopup;
